export default __webpack_public_path__ + "static/media/07_zebrik-min.2468de65.jpg";